<template>
    <div v-if="count !== 0"
        class="pagination-area d-flex flex-wrap mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center gap-3">
        <p class="mb-0 text-paragraph" v-html="page !== undefined ? $t('feature.lists.result_count_range', {
            start: start,
            end: end,
            total: totals
        }) : $t('feature.lists.result_total', {
            count: count ?? 0
        })">
        </p>

        <nav class="ms-auto" v-if="page !== undefined">
            <ul class="pagination mb-0 d-flex align-items-baseline">
                <li class="page-item">
                    <a class="page-link" aria-label="First"
                        :class="[{ 'disabled': currentPage === 1, 'cursor-pointer': prevEnabled }]"
                        v-on:click="$emit('change', 1)">
                        <i class="ph ph-caret-double-left"></i>
                    </a>
                </li>
                <li class="page-item">
                    <a class="page-link" aria-label="Previous"
                        :class="[{ 'disabled': !prevEnabled, 'cursor-pointer': prevEnabled }]"
                        v-on:click="$emit('change', currentPage - 1)">
                        <i class="ph ph-caret-left"></i>
                    </a>
                </li>
                <li class="page-item">
                    <a class="page-link active cursor-pointer" v-on:click="$emit('change', currentPage)">{{ currentPage
                        }}</a>
                </li>
                <span class="mx-1">
                    {{ $t('feature.lists.out_of') }}
                </span>
                <li class="page-item">
                    <a class="page-link cursor-pointer"
                        :class="[{ 'disabled': !nextEnabled, 'cursor-pointer': nextEnabled }]"
                        v-on:click="$emit('change', pages)">{{ pages }}</a>
                </li>
                <li class="page-item">
                    <a class="page-link" aria-label="Next"
                        :class="[{ 'disabled': !nextEnabled, 'cursor-pointer': nextEnabled }]"
                        v-on:click="$emit('change', currentPage + 1)">
                        <i class="ph ph-caret-right"></i>
                    </a>
                </li>
                <li class="page-item">
                    <a class="page-link" aria-label="Last"
                        :class="[{ 'disabled': currentPage === pages, 'cursor-pointer': nextEnabled }]"
                        v-on:click="$emit('change', pages)">
                        <i class="ph ph-caret-double-right"></i>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: "TablePagination",
    props: {
        count: {
            type: Number,
            required: true
        },
        page: {
            type: Number,
            required: false
        },
        total: {
            type: Number,
            required: false
        },
        pages: {
            type: Number,
            required: false
        },
        per_page: {
            type: Number,
            required: false,
            default: 20
        },
    },
    computed: {
        currentPage(): number { return this.page ?? 1; },
        prevEnabled(): boolean { return this.currentPage > 1 },
        nextEnabled(): boolean { return this.currentPage < (this.pages ?? this.currentPage) },
        prevIndex(): number { return this.currentPage - 1; },
        nextIndex(): number { return this.currentPage + 1; },
        start(): number {
            return (this.per_page * ((this.page ?? 1) - 1)) + 1
        },
        end(): number {
            return this.start + this.count - 1
        },
        totals(): number {
            return this.total ?? 0
        }
    },
})
</script>